// CAT Mock 3 — QA section.
const catMock3Qa = [
  {
    id: 47,
    type: "mcq",
    question: "A shopkeeper marks his goods 25% above cost price and allows a 10% discount on the marked price. He also uses a false weight of 800 g in place of 1 kg. What is his overall profit percentage?",
    options: [
      "A. 12.5%",
      "B. 35%",
      "C. 40.625%",
      "D. 42.5%"
    ],
    answer: "C"
  },
  {
    id: 48,
    type: "tita",
    question: "A and B together can finish a job in 12 days, B and C together in 15 days, and A and C together in 20 days. All three start working together; A leaves after 4 days, and B leaves 2 days after that. In how many days in total is the job completed?",
    answer: "34"
  },
  {
    id: 49,
    type: "mcq",
    question: "If log₃x + log₉y = 4 and log₃y − log₉x = 3, then xy equals:",
    options: [
      "A. 243",
      "B. 729",
      "C. 2187",
      "D. 6561"
    ],
    answer: "B"
  },
  {
    id: 50,
    type: "tita",
    question: "How many divisors of 10800 are perfect squares?",
    answer: "12"
  },
  {
    id: 51,
    type: "mcq",
    question: "Two trains start at the same time from stations X and Y, 300 km apart, and travel towards each other. After they meet, the train from X takes 4 hours to reach Y and the train from Y takes 9 hours to reach X. What is the speed of the train from X?",
    options: [
      "A. 25 km/h",
      "B. 30 km/h",
      "C. 36 km/h",
      "D. 40 km/h"
    ],
    answer: "B"
  },
  {
    id: 52,
    type: "tita",
    question: "A vessel contains 80 litres of pure milk. 8 litres are removed and replaced with water, and this operation is performed three times in all. How many litres of milk remain in the vessel? (Enter the answer correct to two decimal places.)",
    answer: "58.32"
  },
  {
    id: 53,
    type: "mcq",
    question: "A triangle has sides 13 cm, 14 cm and 15 cm. What is the distance between its incentre and its circumcentre?",
    options: [
      "A. √65/8 cm",
      "B. 1 cm",
      "C. 9/8 cm",
      "D. √63/8 cm"
    ],
    answer: "A"
  },
  {
    id: 54,
    type: "tita",
    question: "The sum of the first n terms of an arithmetic progression is 3n² + 5n. What is the sum of its 11th to 20th terms (both inclusive)?",
    answer: "950"
  },
  {
    id: 55,
    type: "mcq",
    question: "If α and β are the roots of x² − 6x + 4 = 0, then √α + √β equals:",
    options: [
      "A. 2√2",
      "B. √10",
      "C. √14",
      "D. 4"
    ],
    answer: "B"
  },
  {
    id: 56,
    type: "tita",
    question: "The difference between the compound interest (compounded annually) and the simple interest on a certain sum for 3 years at 10% per annum is ₹620. What is the sum (in ₹)?",
    answer: "20000"
  },
  {
    id: 57,
    type: "mcq",
    question: "In how many ways can the letters of the word BALLOON be arranged so that the two L's are not next to each other?",
    options: [
      "A. 720",
      "B. 960",
      "C. 900",
      "D. 1080"
    ],
    answer: "C"
  },
  {
    id: 58,
    type: "tita",
    question: "A function f satisfies f(x) + 2f(1/x) = 3x for every non-zero real x. What is the value of f(2)?",
    answer: "-1"
  },
  {
    id: 59,
    type: "mcq",
    question: "How many integers x satisfy |x − 3| + |x + 2| ≤ 9?",
    options: [
      "A. 8",
      "B. 9",
      "C. 10",
      "D. 11"
    ],
    answer: "C"
  },
  {
    id: 60,
    type: "tita",
    question: "The average of 11 numbers is 50. The average of the first six is 49 and the average of the last six is 52. What is the sixth number?",
    answer: "56"
  },
  {
    id: 61,
    type: "mcq",
    question: "A, B and C start a business with ₹12,000, ₹16,000 and ₹20,000 respectively. After 4 months A withdraws half of his capital, and after 6 months (from the start) B adds ₹8,000. Out of an annual profit of ₹36,000, what is A's share?",
    options: [
      "A. ₹7,200",
      "B. ₹6,000",
      "C. ₹8,000",
      "D. ₹9,000"
    ],
    answer: "B"
  },
  {
    id: 62,
    type: "tita",
    question: "What is the remainder when 7¹⁰⁰ is divided by 13?",
    answer: "9"
  },
  {
    id: 63,
    type: "mcq",
    question: "What is the area (in square units) of the triangle formed by the lines y = x, y = −x and y = 2x + 3?",
    options: [
      "A. 1.5",
      "B. 3",
      "C. 4.5",
      "D. 6"
    ],
    answer: "B"
  },
  {
    id: 64,
    type: "tita",
    question: "In how many ways can 12 identical balls be placed in 4 distinct boxes so that every box contains at least 2 balls?",
    answer: "35"
  },
  {
    id: 65,
    type: "mcq",
    question: "A solid metal sphere of radius 6 cm is melted and recast into solid cones, each of base radius 3 cm and height 4 cm. How many cones are obtained?",
    options: [
      "A. 18",
      "B. 27",
      "C. 32",
      "D. 24"
    ],
    answer: "D"
  },
  {
    id: 66,
    type: "tita",
    question: "A sequence is defined by x₁ = 1 and xₙ₊₁ = xₙ + 2n for n ≥ 1. What is x₂₀?",
    answer: "381"
  },
  {
    id: 67,
    type: "mcq",
    question: "At what time after 4:00 are the hour and minute hands of a clock at right angles to each other for the first time?",
    options: [
      "A. 4:05 5/11",
      "B. 4:10 10/11",
      "C. 4:21 9/11",
      "D. 4:38 2/11"
    ],
    answer: "A"
  },
  {
    id: 68,
    type: "tita",
    question: "If x + 1/x = 3, what is the value of x⁵ + 1/x⁵?",
    answer: "123"
  }
];

export default catMock3Qa;
